import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Alert.css";

const alertVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 40 },
};

/**
 * Alert component
 * @param {boolean} show - Whether to show the alert
 * @param {string} message - The alert message
 * @param {function} onClose - Function to close the alert
 * @param {string} [type] - Alert type: 'success', 'error', 'info', 'warning'
 */
const Alert = ({ show, message, onClose, type = "info" }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className={`alert alert-${type}`}
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={alertVariants}
          transition={{ duration: 0.4, type: "spring" }}
        >
          <span className="alert-message">{message}</span>
          <button
            className="alert-close"
            onClick={onClose}
            aria-label="Close alert"
          >
            &times;
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Alert;
